'use client'

import { useQuery } from '@tanstack/react-query'

import { roomQueries } from '@/entities/room'
import { useRouter } from '@/shared/i18n'
import { Chip } from '@/shared/ui'

export const KeywordList = () => {
  const router = useRouter()

  const { data } = useQuery({
    ...roomQueries.recommendSearchKeywords(),
    staleTime: Infinity,
    enabled: false,
  })

  const keywords = data?.keywords ?? []

  const handleClick = (keyword: string) => () => {
    router.push(`/guest/room?keyword=${keyword}`)
  }

  return (
    <ul className="flex w-[calc(100vw-32px)] touch-pan-x gap-2 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      {keywords.map(keyword => (
        <li key={keyword}>
          <Chip
            variant="solid"
            onClick={handleClick(keyword)}
            className="typo-body2-reading h-9 min-w-15 text-gray-900 hover:text-gray-900 active:bg-purple-50 active:text-gray-900"
          >
            {keyword}
          </Chip>
        </li>
      ))}
    </ul>
  )
}
